import { JsonProperty } from "../../../models/utilities/json-property";
import { ValidateProperty } from "../../../models/utilities/validate-property";

/**
 * Class for creating a pickup
 */
export class PickupCreate { 

    @ValidateProperty({ required : true })
    public dealerId : string = '';

    @JsonProperty({ toType: 'datetime-specific' })
    @ValidateProperty({ required : true })
    public pickupTimeLocal : Date = new Date();

    @ValidateProperty({ required: true })
    public serviceCenterId : string = '';
    
    @ValidateProperty({ required: true })
    public orders : string[] = [];

}
